import { DetailsSubHeader } from "../../../../../components/sectionHeader";
import { type Props as DetailsSubHeaderProps } from "../../../../../components/sectionHeader/sectionSubHeader/SectionSubHeader";
import { type RootState } from "../../../../Application/globaltypes/redux";
import { connect } from "react-redux";

export type MessageDetailsSubheaderContainerProps = DetailsSubHeaderProps & {
  showLastModified: boolean;
};

const mapStateToProps = (state: RootState, ownProps: MessageDetailsSubheaderContainerProps) => ({
  isUpdateInProgress: state.library.messages.details.messageEntityStateReducer.isEntityCommandInProgress,
  lastModifiedDateTime: ownProps.showLastModified
    ? state.library.messages.details.messageEntityStateReducer.lastModifiedDateTime ?? ownProps.lastModifiedDateTime
    : undefined,
});

export default connect(mapStateToProps)(DetailsSubHeader);
